// extracted by mini-css-extract-plugin
export default {"classified":"Character_classified__lV1mj"};